<template>
    <div class="custom-view-wrapper">
        <p class="text-center text-muted" v-html="options.message"/>
        <div v-if="hasSwitch" class="confirm-switch-wrap">
            <label class="confirm-switch-label" @click.stop>
                <input
                    type="checkbox"
                    class="confirm-switch-input"
                    v-model="switchEnabled"
                />
                <span class="confirm-switch-slider"/>
                <span class="confirm-switch-text">{{ switchLabel }}</span>
            </label>
        </div>
        <button class="nav-link btn btn-xs blue " href="#" @click="cancel()" style="border-radius: 0px;">Cofnij</button>
        <button class="nav-link btn btn-xs blue pull-right" href="#" @click="confirmWithPayload()" style="border-radius: 0px;">Potwierdź</button>
    </div>
</template>

<script>
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'

export default {
    name: 'Confirmation',
    mixins: [DialogMixin],
    components: {
    },
    data() {
        return {
            switchEnabled: !!this.options.switch?.defaultValue
        };
    },
    computed: {
        hasSwitch() {
            return !!this.options.switch;
        },
        switchLabel() {
            return this.options.switch?.label || '';
        }
    },
    methods: {
        confirmWithPayload() {
            this.proceed({
                switchValue: this.switchEnabled
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.confirm-switch-wrap {
    margin: 10px 0 14px;
}
.confirm-switch-label {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    cursor: pointer;
    user-select: none;
}
.confirm-switch-input {
    display: none;
}
.confirm-switch-slider {
    width: 40px;
    height: 22px;
    border-radius: 999px;
    background: #cfd8dc;
    position: relative;
    transition: background-color 0.2s ease;
}
.confirm-switch-slider::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--dm-surface, #fff);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease;
}
.confirm-switch-input:checked + .confirm-switch-slider {
    background: #0d6efd;
}
.confirm-switch-input:checked + .confirm-switch-slider::after {
    transform: translateX(18px);
}
.confirm-switch-text {
    color: var(--dm-text-muted, #4b5563);
    font-size: 13px;
}
</style>
